import {BaseStore} from 'fluxible/addons';
import Actions from '../constants/Actions';
import Immutable from 'immutable';

function buildState(store, favorites) {
  store.favorites = Immutable.fromJS(favorites);
  store.favoriteKeys = store.favorites.map(favorite => {
    return favorite.get('url');
  }).toSet();
}

class FavoriteStore extends BaseStore {
  static storeName = 'FavoriteStore';

  static handlers = {
    [Actions.FAVORITES_RECEIVED]: 'handleFavoritesReceived'
  };

  constructor(dispatcher) {
    super(dispatcher);
    this.favorites = Immutable.Seq();
    this.favoriteKeys = Immutable.Set();
  }

  dehydrate() {
    return {
      favorites: this.favorites
    };
  }

  rehydrate({ favorites }) {
    buildState(this, favorites);
  }

  handleFavoritesReceived(favorites) {
    buildState(this, favorites);
    this.emitChange(this.favorites);
  }

  getFavorites() {
    return this.favorites.toJS();
  }

  isFavorite(url) {
    return this.favoriteKeys.contains(url);
  }
}

export default FavoriteStore;



// WEBPACK FOOTER //
// ./src/stores/FavoriteStore.js